export const AppLoader = () => {
    return (
        <div className="d-flex align-items-center justify-content-center h-100">
            <img className='loader-img' src={`${process.env.PUBLIC_URL}/static/images/loader.svg`} alt="loader-icon" />
        </div>
    )
};